module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/banner/zh-hant-7b109fc8166d1a4e819711b1bc7be6a1.jpg";